import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursoCarruselReducer(state= initialState.cursoCarrusel, action){
	switch(action.type){
		case types.LOAD_CURSOS_CARRUSEL_SUCCESS:
            
			return action.datos;		
	
		default:
			return state;
	}
}